import { Logger } from "../logging";

const isDev = process.env.REACT_APP_ENVIRONMENT === 'development';

export const skipForDevelopment = (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
	if (!isDev)
		return;

	descriptor.value = function() {
		Logger.logTrace(`[Skip:Development] ${target.constructor.name}.${propertyKey}`)
	};
}